import React, { useState } from "react";
import TableContainer from "../../components/Common/DataTableContainer";
import { Row, Col, CardBody, Card, Container } from "reactstrap";

const initialData = [
    { id: 1, name: "James Dawson", role: "General Manager", salary: "$120,000", status: "Owner" },
    { id: 2, name: "Ashleigh Dawson", role: "CFO", salary: "$120,000", status: "Owner" },
    { id: 3, name: "Emily Carter", role: "Marketing Manager", salary: "$90,000", status: "Employee" },
    { id: 4, name: "Liam Reynolds", role: "Accountant", salary: "$130,000", status: "Employee" },
];

const Step8 = () => {
    const [tableData, setTableData] = useState(initialData);
    const [filteredData, setFilteredData] = useState([]);
    const [showFilteredTable, setShowFilteredTable] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [showBusinessSellOptions, setShowBusinessSellOptions] = useState(false);
    const [showInsuranceInput, setShowInsuranceInput] = useState(false);
    const [wageInputs, setWageInputs] = useState({});
    const [wageInputs1, setWageInputs1] = useState({});
    const [yesSelected2, setYesSelected2] = useState(null);
    const [yesSelected, setYesSelected] = useState(null);

    const itemsPerPage = 223423423;

    const handleWageChange = (id, value) => {
        setWageInputs(prev => ({ ...prev, [id]: value })); // Update local state for immediate change
    };
    
    const handleWageChange1 = (id, value) => {
        setWageInputs1(prev => ({ ...prev, [id]: value })); // Update local state for immediate change
    };

    // Sync to filteredData only when input loses focus
    const handleWageBlur = (id) => {
        setFilteredData(prevData =>
            prevData.map(row =>
                row.id === id ? { ...row, commercialWagePayable: wageInputs[id] || "" } : row
            )
        );
    };

    const handleWageBlur1 = (id) => {
        setFilteredData(prevData =>
            prevData.map(row =>
                row.id === id ? { ...row, commercialWagePayable1: wageInputs[id] || "" } : row
            )
        );
    };

    const handleStatusChange = (id, newStatus) => {
        setTableData(prevData =>
            prevData.map(item =>
                item.id === id ? { ...item, status: newStatus } : item
            )
        );
    };

    const handleNext = () => {
        const owners = tableData.filter(item => item.status === "Owner");
        setFilteredData(owners);
        setShowFilteredTable(true);
        setCurrentPage(0);
    };

    const handlePrevious = () => {
        setShowFilteredTable(false);
        setShowBusinessSellOptions(false);
    };

    const displayedData = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const commonColumns = [
        { accessorKey: "name", header: "Name", cell: info => info.getValue() },
        { accessorKey: "role", header: "Role", cell: info => info.getValue() },
        { accessorKey: "salary", header: "Salary", cell: info => info.getValue() },
        {
            accessorKey: "status",
            header: "Status",
            cell: ({ row }) => {
                const { original } = row;
                return (
                    <Container>
                        <label>
                            <input
                                type="radio"
                                name={`status-${original.id}`}
                                value="Employee"
                                checked={original.status === "Employee"}
                                onChange={() => handleStatusChange(original.id, "Employee")}
                            /> Employee
                        </label>
                        <label className="ms-3">
                            <input
                                type="radio"
                                name={`status-${original.id}`}
                                value="Owner"
                                checked={original.status === "Owner"}
                                onChange={() => handleStatusChange(original.id, "Owner")}
                            /> Owner
                        </label>
                    </Container>
                );
            },
        },
    ];

    const secondTableColumns = [
        { accessorKey: "name", header: "Name", cell: info => info.getValue() },
        { accessorKey: "role", header: "Role", cell: info => info.getValue() },
        { accessorKey: "salary", header: "Salary", cell: info => info.getValue() },
        {
            accessorKey: "commercialWagePayable",
            header: "Commercial Wage Payable",
            cell: ({ row }) => {
                const { original } = row;
                return (
                    <input
                        type="text"
                        className="form-control"
                        value={wageInputs[original.id] ?? original.commercialWagePayable ?? "$150,000"}
                        onChange={(e) => handleWageChange(original.id, e.target.value)}
                        onBlur={() => handleWageBlur(original.id)} // Sync to filteredData on blur
                    />
                );
            },
        },
    ];
    
    const thirdTableColumns = [
        { accessorKey: "name", header: "Name", cell: info => info.getValue() },
        { accessorKey: "role", header: "Role", cell: info => info.getValue() },
        { accessorKey: "salary", header: "Salary", cell: info => info.getValue() },
        {
            accessorKey: "commercialWagePayable1",
            header: "Commercial Wage Payable",
            cell: ({ row }) => {
                const { original } = row;
                return (
                    <input
                        type="text"
                        className="form-control"
                        value={wageInputs1[original.id] ?? original.commercialWagePayable1 ?? "$150,000"}
                        onChange={(e) => handleWageChange1(original.id, e.target.value)}
                        onBlur={() => handleWageBlur1(original.id)} // Sync to filteredData on blur
                    />
                );
            },
        },
    ];


    return (
        <div className="mt-5 mb-5 container">
            {!showFilteredTable ? (
                <>
                    <h3>Select employees who are owners or are related parties</h3>
                    <TableContainer columns={commonColumns} data={tableData} tableClass="table" theadClass="table-light" divClassName="table-responsive" isBordered={true} />
                    <button className="btn btn-primary mt-3" onClick={handleNext}>Next</button>
                </>
            ) : (
                <>
                    <h3>What would it cost to hire someone external for the same role?</h3>
                    <TableContainer columns={secondTableColumns} data={displayedData} tableClass="table" theadClass="table-light" divClassName="table-responsive" isBordered={true} />
                    <div className="d-flex justify-content-between mt-3">
                        <button className="btn btn-secondary" onClick={handlePrevious}>Previous</button>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                if ((currentPage + 1) * itemsPerPage >= filteredData.length) {
                                    setShowBusinessSellOptions(true);
                                } else {
                                    setCurrentPage(prev => prev + 1);
                                }
                            }}
                            disabled={showBusinessSellOptions}
                        >Next</button>
                    </div>

                    <h3>Is there anyone who works in the business who isnt paid as an employee?</h3>
                    <TableContainer columns={thirdTableColumns} data={displayedData} tableClass="table" theadClass="table-light" divClassName="table-responsive" isBordered={true} />
                    {/* <div className="d-flex justify-content-between mt-3">
                        <button className="btn btn-secondary" onClick={handlePrevious}>Previous</button>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                if ((currentPage + 1) * itemsPerPage >= filteredData.length) {
                                    setShowBusinessSellOptions(true);
                                } else {
                                    setCurrentPage(prev => prev + 1);
                                }
                            }}
                            disabled={showBusinessSellOptions}
                        >Next</button>
                    </div> */}

                    <div className="mb-3 mt-3">
                        <label className="form-label">Is the business’s Workers' Compensation insurance up to date?</label>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" id="insuranceYes" name="insuranceStatus" onChange={() => setShowInsuranceInput(false)} />
                            <label className="form-check-label" htmlFor="insuranceYes">Yes</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" id="insuranceNo" name="insuranceStatus" onChange={() => setShowInsuranceInput(true)} />
                            <label className="form-check-label" htmlFor="insuranceNo">No</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" id="insuranceNotRequired" name="insuranceStatus" onChange={() => setShowInsuranceInput(false)} />
                            <label className="form-check-label" htmlFor="insuranceNotRequired">Not required for my business</label>
                        </div>
                        {showInsuranceInput && (
                            <div className="form-check mt-2">
                                <label className="form-label" htmlFor="data">How much is outstanding?</label>
                                <input type="text" className="form-control" id="data" placeholder="AUD $XXX" />
                            </div>
                        )}
                    </div>
                    <div>
                        <div className="mb-5 mt-3">
                            <label className="form-label">Does the stock level on your balance sheet accurately reflect what you actually have on hand?</label>
                            <div className="d-flex">
                                <button
                                    type="button"
                                    className="btn ms-2"
                                    style={{ backgroundColor: yesSelected2 === true ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected2 === true ? "white" : "#77bc4b" }}
                                    onClick={() => setYesSelected2(true)}
                                >
                                    ✓ YES
                                </button>
                                <button
                                    type="button"
                                    className="btn ms-2"
                                    style={{ backgroundColor: yesSelected2 === false ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected2 === false ? "white" : "#77bc4b" }}
                                    onClick={() => setYesSelected2(false)}
                                >
                                    NO
                                </button>
                            </div>
                            {yesSelected2 === true && (
                                <div>
                                    <div className="mb-3 mt-3">
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="abn">What's their role?</label>
                                            <input type="text" className="form-control" id="abn" placeholder="Enter Role" />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="industry">Current annual pay:</label>
                                            <input type="text" className="form-control" id="industry" placeholder="Enter Current annual pay" />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="address">Market annual pay:</label>
                                            <input type="text" className="form-control" id="address" placeholder="Enter Market annual pay" />
                                        </div>
                                    </div>

                                    <label className="form-label">Any others in your business being paid above or below market rates?</label>
                                    <div className="d-flex">
                                        <button
                                            type="button"
                                            className="btn ms-2"
                                            style={{ backgroundColor: yesSelected === true ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected === true ? "white" : "#77bc4b" }}
                                            onClick={() => setYesSelected(true)}
                                        >
                                            ✓ YES
                                        </button>
                                        <button
                                            type="button"
                                            className="btn ms-2"
                                            style={{ backgroundColor: yesSelected === false ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected === false ? "white" : "#77bc4b" }}
                                            onClick={() => setYesSelected(false)}
                                        >
                                            NO
                                        </button>
                                    </div>

                                    {yesSelected === true && (
                                        <div className="mb-3 mt-3">
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="abn">What's their role?</label>
                                                <input type="text" className="form-control" id="abn" placeholder="Enter Role" />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="industry">Current annual pay:</label>
                                                <input type="text" className="form-control" id="industry" placeholder="Enter Current annual pay" />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="address">Market annual pay:</label>
                                                <input type="text" className="form-control" id="address" placeholder="Enter Market annual pay" />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>

                </>
            )}
        </div>
    );
};

export default Step8;
